import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const GenderFilter = ({ filterValues, handleFilterChange }) => {
  const genderOptions = [
    { label: 'Male', value: 'MALE' },
    { label: 'Female', value: 'FEMALE' },
    { label: 'Others', value: 'OTHERS' },
  ]

  const selectedValues = (filterValues?.selectedGender || []).map(item =>
    typeof item === 'object' ? item.value : item
  )

  return (
    <FilterCheckBoxComp
      options={genderOptions}
      value={selectedValues}
      onChange={handleFilterChange}
      valueParam="value"
      labelParam="label"
      valueKey="selectedGender"
    />
  )
}

export default GenderFilter
